import styled from "styled-components"

import { minWidth } from "utils"

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 2.4rem;
  gap: 3.6rem;

  ${minWidth.tablet`
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.5rem;
  `}
`

export const TitleAndList = styled.div`
  display: flex;
  flex: 1 1 48%;
  flex-direction: column;
  gap: 2.4rem;
`

export const TitleWithIcon = styled.h4`
  display: flex;
  align-items: center;
  gap: 2rem;
`

export const Title = styled.h4`
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 2.5rem;
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`

export const ListItemIcon = styled.div`
  padding-top: 0.3rem;
`

export const ListItem = styled.div`
  display: flex;
  gap: 1.2rem;
  align-items: flex-start;
`

export const ListItemValue = styled.div`
  font-size: 1.6rem;

  > p {
    margin: 0;
    padding: 0;
  }
`
